export default "__VITE_ASSET__Dn594IxW__"